export default __webpack_public_path__ + "static/media/themify9f24.f0fc8c79.svg";